export default __webpack_public_path__ + "static/media/pavlaka_12_0-41l.90a89174.jpg";